import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/',
        name: 'home',
        component: () =>
            import('./pages/Login.vue'),
        meta: {
            plainLayout: true
        },
    },
    {
        path: '/login',
        name: 'login',
        exact: true,
        component: () =>
            import('./pages/Login.vue'),
        meta: {
            plainLayout: true,
        },
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        exact: true,
        component: () =>
            import('./components/Dashboard.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ label: 'Dashboard' }],
        },
    },
    {
        path: '/:notFound',
        name: 'not-found',
        exact: true,
        component: () =>
            import('./pages/NotFound.vue'),
        meta: {
            plainLayout: true,
        },
    },
    {
        path: '/adminlist',
        name: 'listclient',
        exact: true,
        component: () =>
            import('./components/admin/AdminList.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ label: 'Admin' }],
        },
    },
    {
        path: '/admin/dashboard/:adminId?',
        name: 'admindashboard',
        exact: true,
        component: () =>
            import('./components/admintabs/AdminDashboard.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'Dashboard' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/admintinfo',
        name: 'admininfo',
        exact: true,
        component: () =>
            import('./components/admintabs/AdminInfoTab.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Dashboard', label: 'Admin Info' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/adminconfig',
        name: 'adminconfig',
        exact: true,
        component: () =>
            import('./components/admintabs/AdminConfigTab.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Dashboard', label: 'Admin Config' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/modulesetting',
        name: 'modulesetting',
        exact: true,
        component: () =>
            import('./components/admintabs/ModuleSettingTab.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Dashboard', label: 'Module Settings' }],
        },
    },
    // {
    //     path: '/admin/dashboard/:adminSubId?/adminplan',
    //     name: 'adminplan',
    //     exact: true,
    //     component: () =>
    //         import('./components/admintabs/AdminPlanTab.vue'),
    //     meta: {
    //         requiresAuth: true,
    //         checkModuleAccess: false,
    //         breadcrumb: [{ parent: 'Admin', label: 'Admin Plan' }],
    //     },
    // },
    {
        path: '/admin/dashboard/:adminSubId?/admincomponentcharges',
        name: 'admincomponentcharges',
        exact: true,
        component: () =>
            import('./components/admintabs/AdminComponentCharges.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'Admin Component Charges' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/addfund',
        name: 'adminaddfund',
        exact: true,
        component: () =>
            import('./components/admintabs/AddFundTab.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'Add Fund' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/admindynamicmessage',
        name: 'admindynamicmessage',
        exact: true,
        component: () =>
            import('./components/admintabs/DynamicsMessages.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'Admin Dynamic Messages' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/callcenter',
        name: 'callcenter',
        exact: true,
        component: () =>
            import('./components/admintabs/CallCenterSettings.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'Call Center Settings' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/notification',
        name: 'notification',
        exact: true,
        component: () =>
            import('./components/admintabs/NotificationSettings.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'Notification' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/paymentgatewaydetails',
        name: 'paymentgatewaydetails',
        exact: true,
        component: () =>
            import('./components/admintabs/PaymentGetWay.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'Payment Gateway' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/adminrole',
        name: 'adminrole',
        exact: true,
        component: () =>
            import('./components/admintabs/AdminRole.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Dashboard', label: 'Admin Role' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/admindocument',
        name: 'admindocument',
        exact: true,
        component: () =>
            import('./components/admintabs/AdminDocument.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Dashboard', label: 'Admin Document', }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/service-setting',
        name: 'service-setting',
        exact: true,
        component: () =>
            import('./components/admintabs/ServiceSetting.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Dashboard', label: 'Service Setting' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/add-debit',
        name: 'add-debit',
        exact: true,
        component: () =>
            import('./components/admintabs/AddDebit.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Dashboard', label: 'Add Debit' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/template-actions',
        name: 'template-actions',
        exact: true,
        component: () =>
            import('./components/admintabs/TemplateActions.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'Template Actions' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/whatsapp-template-settings',
        name: 'whatsapp-template-settings',
        exact: true,
        component: () =>
            import('./components/admintabs/WhatsAppTemplateSettings.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'WhatsApp Template Settings' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/app-popup',
        name: 'AppPopupSettings',
        exact: true,
        component: () =>
            import('./components/admintabs/AppPopupSettings.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'App Popup' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/app-users',
        name: 'AppUsersList',
        exact: true,
        component: () =>
            import('./components/admintabs/AppUsersList.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'App Users' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/app-version-setting',
        name: 'AppVersionSetting',
        exact: true,
        component: () =>
            import('./components/admintabs/AppVersionSetting.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Client', label: 'App Version Settings' }],
        },
    },
    {
        path: '/adminemployee',
        name: 'listadminemployee',
        exact: true,
        component: () =>
            import('./components/admin/AdminEmployee.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin Users', label: 'List Admin Users' }],
        },
    },
    {
        path: '/billing/plan',
        name: 'billingplan',
        exact: true,
        component: () =>
            import('./components/BillingPlan.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Billing', label: 'Plan' }],
        },
    },
    {
        path: '/adminAccStmt',
        name: 'AdminAccountStatement',
        exact: true,
        component: () =>
            import('./components/adminbilling/AdminAccountStatement.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin Billing', label: 'Account Statement' }],
        },
    },
    {
        path: '/billing/plan/component/:planrowId?',
        name: 'billingplancomponent',
        exact: true,
        component: () =>
            import('./components/billing/PlanComponent.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Billing', label: 'Components' }],
        },
    },
    {
        path: '/admintaxinvoice',
        name: 'billinginvoice',
        exact: true,
        component: () =>
            import('./components/adminbilling/TaxInvoice.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin Billing', label: 'Tax Invoice' }],
        },
    },
    {
        path: '/adminpaymentreceipt',
        name: 'billingreceipt',
        exact: true,
        component: () =>
            import('./components/adminbilling/PaymentReceipt.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin Billing', label: 'Payment Receipt' }],
        },
    },
    {
        path: '/adminlivebalance',
        name: 'clientbalance',
        exact: true,
        component: () =>
            import('./components/adminbilling/LiveBalance.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin Billing', label: 'Admin Live Balance' }],
        },
    },
    {
        path: '/users',
        name: 'listusers',
        exact: true,
        component: () =>
            import('./components/user/Users.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Users', label: 'List Users' }],
        },
    },
    {
        path: '/D_I_D/Numbers/free-numbers',
        name: 'freeNumbers',
        exact: true,
        component: () =>
            import('./components/cloudtelephony/freeDIDNumbers.vue'),
        meta: {
            requiresAuth: false,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Cloud Telephony', label: 'Free Numbers' }],
        },
    },
    {
        path: '/D_I_D/Numbers/admin-numbers',
        name: 'adminNumbers',
        exact: true,
        component: () =>
            import('./components/cloudtelephony/adminDIDNumbers.vue'),
        meta: {
            requiresAuth: false,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Cloud Telephony', label: 'Admin Numbers' }],
        },
    },
    {
        path: '/D_I_D/Numbers/notice-period',
        name: 'underNoticePeriodNumbers',
        exact: true,
        component: () =>
            import('./components/cloudtelephony/underNoticePeriodNumbers.vue'),
        meta: {
            requiresAuth: false,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Cloud Telephony', label: 'Under Notice Period Numbers' }],
        },
    },
    {
        path: '/D_I_D/Numbers/submitted-request-to-operator',
        name: 'submittedRequestToOperator',
        exact: true,
        component: () =>
            import('./components/cloudtelephony/requestSubmittedToOperator.vue'),
        meta: {
            requiresAuth: false,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Cloud Telephony', label: 'Request Submitted To Operator' }],
        },
    },
    {
        path: '/D_I_D/Numbers/released-numbers',
        name: 'releasedNumbers',
        exact: true,
        component: () =>
            import('./components/cloudtelephony/releasedNumbers.vue'),
        meta: {
            requiresAuth: false,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Cloud Telephony', label: 'Released Numbers' }],
        },
    },
    {
        path: '/settings/DefaultTunes',
        name: 'listdefaulttunes',
        exact: true,
        component: () =>
            import('./components/settings/DefaultTunes.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Settings', label: ' Default Tunes' }],
        },
    },
    {
        path: '/admintabs/templateevent',
        name: 'listemplateevent',
        exact: true,
        component: () =>
            import('./components/admintabs/TemplateEvent.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin Tabs', label: ' Template Event' }],
        },
    },
    {
        path: '/admin/action/event/:eventId?',
        name: 'addEditEventTemplate',
        exact: true,
        component: () =>
            import('./components/admintabs/AddEditEventTemplate.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'Event Templates' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/RCS-template-settings',
        name: 'RCS-template-settings',
        exact: true,
        component: () =>
            import('./components/admintabs/RCSTemplateSettings.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'RCS Template Settings' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/critical-permissions',
        name: 'critical-permissions',
        exact: true,
        component: () =>
            import('./components/admintabs/CriticalPermissions.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'Critical Permissions' }],
        },
    },
    {
        path: '/hosts',
        name: 'listhosts',
        exact: true,
        component: () =>
            import('./components/host/hostDetails.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Host', label: 'List Hosts' }],
        },
    },
    {
        path: '/hostdetails/:hostId?/:clientId?',
        name: 'hostDetails',
        exact: true,
        component: () =>
            import('./components/host/HostAllDetails.vue'),
        meta: {
            // requiresAuth: true,
            // checkModuleAccess: false,
            breadcrumb: [{ parent: 'Host', label: 'Host Details' }],
        },
    },
    {
        path: '/hostAccStmt',
        name: 'HostAccountStatement',
        exact: true,
        component: () =>
            import('./components/hostbilling/HostAccountStatement.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Host Billing', label: 'Account Statement' }],
        },
    },
    {
        path: '/visitors',
        name: 'listvisitors',
        exact: true,
        component: () =>
            import('./components/guest/Visitors.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Guests', label: 'Guests List' }],
        },

    },
    {
        path: '/support-tickets/new-ticket',
        name: 'newTicktes',
        exact: true,
        component: () =>
            import('./components/supportTickets/newTickets.vue'),
        meta: {
            requiresAuth: false,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Support Tickets', label: 'New Tickets' }],
        },
    },
    {
        path: '/support-tickets/open-ticket',
        name: 'openTicktes',
        exact: true,
        component: () =>
            import('./components/supportTickets/openTickets.vue'),
        meta: {
            requiresAuth: false,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Support Tickets', label: 'Open Tickets' }],
        },
    },

    {
        path: '/support-tickets/closed-ticket',
        name: 'closedTicktes',
        exact: true,
        component: () =>
            import('./components/supportTickets/closedTickets.vue'),
        meta: {
            requiresAuth: false,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Support Tickets', label: 'Closed Tickets' }],
        },
    },
    {
        path: '/support-tickets/call-setting',
        name: 'callSetting',
        exact: true,
        component: () =>
            import('./components/supportTickets/callSetting.vue'),
        meta: {
            requiresAuth: false,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Support Tickets', label: 'Call Setting' }],
        },
    },
    {
        path: '/support-tickets/call-logs',
        name: 'callLogs',
        exact: true,
        component: () =>
            import('./components/supportTickets/CallLog.vue'),
        meta: {
            requiresAuth: false,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Support Tickets', label: 'Call Logs' }],
        },
    },

    {
        path: '/settings/superAdminSMSAndEmailSetting',
        name: 'listSuperAdminTemplateActions',
        exact: true,
        component: () =>
            import('./components/settings/SuperAdminSMSAndEmailSetting.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Settings', label: 'Super Admin SMS And Email Settings' }],
        },
    },

    {
        path: '/settings/superAdminTemplateEvent',
        name: 'listSuperAdminTemplateEvent',
        exact: true,
        component: () =>
            import('./components/settings/SuperAdminTemplateEvent.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Settings', label: 'Super Admin Template Event' }],
        },
    },

    {
        path: '/settings/action/event/:eventId?',
        name: 'addEditSuperAdminEventTemplate',
        exact: true,
        component: () =>
            import('./components/settings/AddEditSuperAdminEventTemplate.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Settings', label: 'Super Admin Event Templates' }],
        },
    },

    {
        path: '/settings/companies',
        name: 'listofcompanies',
        exact: true,
        component: () =>
            import('./components/settings/Companies.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Settings', label: 'DLT Companies' }],
        },
    },
    {
        path: '/settings/sms-sender-ids',
        name: 'sms-sender-ids',
        exact: true,
        component: () =>
            import('./components/settings/CompaniesSenderId.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Settings', label: 'SMS Sender Ids' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/web-bot-template-settings',
        name: 'web-bot-template-settings',
        exact: true,
        component: () =>
            import('./components/admintabs/WebBotTemplateSettings.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'Web Bot Template Settings' }],
        },
    },
    {
        path: '/settings/adminSMSAndEmailSetting',
        name: 'listAdminTemplateActions',
        exact: true,
        component: () =>
            import('./components/settings/AdminSMSAndEmailSetting.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Settings', label: 'Admin SMS And Email Settings' }],
        },
    },
    {
        path: '/settings/adminTemplateEvent',
        name: 'listAdminTemplateEvent',
        exact: true,
        component: () =>
            import('./components/settings/AdminTemplateEvent.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Settings', label: 'Admin Template Event' }],
        },
    },
    {
        path: '/settings/action/adminevent/:eventId?',
        name: 'addEditAdminEventTemplate',
        exact: true,
        component: () =>
            import('./components/settings/addEditAdminEventTemplate.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Settings', label: 'Admin Event Templates' }],
        },
    },
    {
        path: '/settings/dashoboardlogos',
        name: 'listDashoboardLogos',
        exact: true,
        component: () =>
            import('./components/settings/DashoboardLogos.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Settings', label: 'Upload Logos' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/web-bot-template-settings-dashboard',
        name: 'web-bot-template-settings-dashboard',
        exact: true,
        component: () =>
            import('./components/admintabs/WebBotTemplateSettingDashboard.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'Web Bot Template Settings Dashboard' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/TemplateDescription',
        name: 'listTemplateDescription',
        exact: true,
        component: () =>
            import('./components/admintabs/TemplateDescription.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: ' Web Bot Template Groups' }],
        },
    },
    {
        path: '/admins/dashboard/:adminSubId?/web-bot-flow',
        name: 'Web-bot-flow',
        exact: true,
        component: () =>
            import('./components/admintabs/WebBotFlowSetting.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'Web Bot Flow' }],
        },
    },
    {
        path: '/admintabs/dashboard/:adminSubId?/chat-bots-settings',
        name: 'chatbotsettings',
        exact: true,
        component: () =>
            import('./components/admintabs/ChatBotSettings.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: ' Chat Bot Settings' }],
        },
    },
    {
        path: '/permission-sets',
        name: 'UsersPermissionSet',
        exact: true,
        component: () =>
            import('./components//user/UsersPermissionSet.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Users', label: 'Permission Sets' }],
        },
    },
    {
        path: '/hosts-users',
        name: 'hostsUsers',
        exact: true,
        component: () =>
            import('./components/host/hostsUsers.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Hosts', label: 'Host Users' }],
        },
    },
    {
        path: '/live-visitors',
        name: 'LiveVisitors',
        exact: true,
        component: () =>
            import('./components/guest/LiveVisitors.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Guests', label: 'Live Guests' }],
        },
    },
    {
        path: '/host-tx-invc',
        name: 'HostTaxInvoices',
        exact: true,
        component: () =>
            import('./components/hostbilling/HostTaxInvoices.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Host Billing', label: 'Tax Invoice' }],
        },
    },
    {
        path: '/whatapp-logs',
        name: 'whatsAppLog',
        exact: true,
        component: () =>
            import('./components/Log/whatsAppLog.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Logs', label: 'WhatsApp Logs' }],
        },
    },
    {
        path: '/webbotlogs',
        name: 'webBotLog',
        exact: true,
        component: () =>
            import('./components/Log/WebBotLog.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Logs', label: 'Web bot Logs' }],
        },
    },
    {
        path: '/smslogs',
        name: 'smsLog',
        exact: true,
        component: () =>
            import('./components/Log/smsLog.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Logs', label: 'SMS Logs' }],
        },
    },
    {
        path: '/incomingcalllogs',
        name: 'incomingCallLog',
        exact: true,
        component: () =>
            import('./components/Log/IncomingCallLog.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Logs', label: 'Incoming Call Logs' }],
        },
    },
    {
        path: '/rcslogs',
        name: 'rcsLog',
        exact: true,
        component: () =>
            import('./components/Log/RcsLogs.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Logs', label: 'RCS Logs' }],
        },
    },
    {
        path: '/outgoingcalllogs',
        name: 'outgoingcalllogs',
        exact: true,
        component: () =>
            import('./components/Log/OutgoingCallLog.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Logs', label: 'Outgoing Call Logs' }],
        },
    },
    {
        path: '/lawinfocement',
        name: 'lawinfocement',
        exact: true,
        component: () =>
            import('./components/police.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Law Inforcement', label: 'Law Inforcement Users' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/admin-permissions',
        name: 'admin-permissions',
        exact: true,
        component: () =>
            import('./components/admintabs/AdminPermissions.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'Admin Permissions' }],
        },
    },
    {
        path: '/listing/firrequesttype',
        name: 'firrequesttype',
        exact: true,
        component: () =>
            import('./components/listing/FirRequestType.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Listing', label: 'FIR Request Type' }],
        },
    },
    {
        path: '/listing/firrequestsubtype',
        name: 'firrequestsubtype',
        exact: true,
        component: () =>
            import('./components/listing/FirRequestSubType.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Listing', label: 'FIR Request Sub Type' }],
        },
    },
    {
        path: '/listing/pccapplicationtype',
        name: 'pccapplicationtype',
        exact: true,
        component: () =>
            import('./components/listing/PccApplicationType.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Listing', label: 'PCC Application Type' }],
        },
    },
    {
        path: '/listing/typeofindustries',
        name: 'typeofindustries',
        exact: true,
        component: () =>
            import('./components/listing/TypeIndustries.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Listing', label: 'Type Of Industries' }],
        },
    },
    {
        path: '/listing/reportreason',
        name: 'reportreason',
        exact: true,
        component: () =>
            import('./components/listing/ReportReason.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Listing', label: 'Report Reason' }],
        },
    },
    {
        path: '/listing/companytype',
        name: 'companytype',
        exact: true,
        component: () =>
            import('./components/listing/CompanyType.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Listing', label: 'Company Type' }],
        },
    },
    {
        path: '/listing/ipcsection',
        name: 'ipcsection',
        exact: true,
        component: () =>
            import('./components/listing/IpcSection.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Listing', label: 'IPC Section' }],
        },
    },
    {
        path: '/listing/employments',
        name: 'employments',
        exact: true,
        component: () =>
            import('./components/listing/Employments.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Listing', label: 'Employments' }],
        },
    },
    {
        path: '/listing/menus',
        name: 'menus',
        exact: true,
        component: () =>
            import('./components/listing/menus/Menus.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Listing', label: 'Menus' }],
        },
    },
    {
        path: '/listing/menus/add',
        name: 'addmenus',
        exact: true,
        component: () =>
            import('./components/listing/menus/AddMenu.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Listing', label: 'Add Menus' }],
        },
    },
    {
        path: '/listing/menus/edit/:id',
        name: 'editmenus',
        exact: true,
        component: () =>
            import('./components/listing/menus/EditMenu.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Listing', label: 'Edit Menus' }],
        },
    },
    {
        path: '/listing/countries',
        name: 'countries',
        exact: true,
        component: () =>
            import('./components/listing/Countries.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Listing', label: 'Countries' }],
        },
    },
    {
        path: '/listing/states',
        name: 'states',
        exact: true,
        component: () =>
            import('./components/listing/States.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Listing', label: 'States' }],
        },
    },
    {
        path: '/listing/districts',
        name: 'districts',
        exact: true,
        component: () =>
            import('./components/listing/Districts.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Listing', label: 'Districts' }],
        },
    },
    {
        path: '/listing/cities',
        name: 'cities',
        exact: true,
        component: () =>
            import('./components/listing/Cities.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Listing', label: 'Cities' }],
        },
    },
    {
        path: '/listing/areas',
        name: 'areas',
        exact: true,
        component: () =>
            import('./components/listing/Areas.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Listing', label: 'Areas' }],
        },
    },
    {
        path: '/billing/clientPayment',
        name: 'ClientPayment',
        exact: true,
        component: () =>
            import('./components/billing/ClientPayment.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Billing', label: 'Client Payment' }],
        },
    },
    {
        path: '/billing/taxinvoice',
        name: 'taxinvoice',
        exact: true,
        component: () =>
            import('./components/billing/TaxInvoice.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Billing', label: 'Tax Invoice' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/configSetting',
        name: 'configSetting',
        exact: true,
        component: () =>
            import('./components/admintabs/CommonConfigSetting.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'Common Configuration Settings' }],
        },
    },
    {
        path: '/admin/dashboard/:adminSubId?/logoSetting',
        name: 'logoSetting',
        exact: true,
        component: () =>
            import('./components/admintabs/CommonLogoSetting.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Admin', label: 'Common Logo Settings' }],
        },
    },
    {
        path: '/listing/complaintrequesttype',
        name: 'complaintrequesttype',
        exact: true,
        component: () =>
            import('./components/listing/ComplaintRequestType.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Listing', label: 'Confidential Complaint Request Type' }],
        },
    },
    {
        path: '/listing/beat-categories',
        name: 'beat-categories',
        exact: true,
        component: () =>
            import('./components/listing/BeatCategory.vue'),
        meta: {
            requiresAuth: true,
            checkModuleAccess: false,
            breadcrumb: [{ parent: 'Listing', label: 'Beat Categories' }],
        },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes
});
router.beforeEach((to, from, next) => {
    const authenticatedUser = localStorage.user_reference;
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const checkModuleAccess = to.matched.some(record => record.meta.checkModuleAccess);
    const moduleId = to.meta.moduleId;
    const permission_fks = [1, 11, 12];

    if (requiresAuth && !authenticatedUser) {
        next('/login');
    }
    else {
        if (checkModuleAccess) {
            if (permission_fks.includes(moduleId)) {
                next();
            } else {
                next(false);
            }
        } else {
            next();
        }

    }

});

export default router;